<template>
  <div class="flex flex-row gap-1 items-center text-yellow-400 font-bold">
    <span class="flex flex-row pb-1">
      <IconComponent
        v-for="n in fullStarCount"
        :key="`full-${n}`"
        icon="star"
        class="text-yellow-400"
      />
      <IconComponent
        v-if="hasHalfStar"
        icon="star-half-alt"
        class="text-yellow-400"
      />
      <IconComponent
        v-for="n in ratingPadding"
        :key="`empty-${n}`"
        icon="star"
        pack="far"
        class="text-yellow-400"
      />
    </span>
    <span v-if="showRating">{{ fixedRating }}</span>
  </div>
</template>

<script>
export default {
  name: "RatingIndicator",
  props: {
    score: {
      type: Number,
      required: true,
    },
    showRating: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ratingNormalized() {
      return Math.round(this.score) / 2;
    },
    fullStarCount() {
      return Math.floor(this.ratingNormalized);
    },
    hasHalfStar() {
      return this.ratingNormalized > this.fullStarCount;
    },
    ratingPadding() {
      return 5 - (this.fullStarCount + (this.hasHalfStar ? 1 : 0));
    },
    fixedRating() {
      return (this.score / 2).toFixed(1);
    },
  },
};
</script>
